module.exports = __webpack_public_path__ + "img/Shopping_Bag.687a0438.svg";